import { IsCouponCodeAvailableQuery } from "@/generated/graphql_billing";
import { graphql, HttpResponse } from "msw";

export const isCouponCodeAvailableHandler =
  graphql.query<IsCouponCodeAvailableQuery>(
    "isCouponCodeAvailable",
    ({ query, variables }) => {
      // if coupon code contains "fail", return false
      if (variables.couponCode.includes("fail")) {
        return HttpResponse.json({
          data: {
            isCouponCodeAvailable: false,
          },
        });
      } else {
        return HttpResponse.json({
          data: {
            isCouponCodeAvailable: true,
          },
        });
      }
    }
  );
